import React, { Component } from 'react'
import { withRouter} from 'react-router-dom'
import DocumentTitle from 'react-document-title' 
import { connect } from 'react-redux'
import { resetPassword } from '../../actions/user'
import ResetPasswordForm from '../../components/forms/account/ResetPasswordForm'
import qs from 'qs'
 

class ResetPasswordContainer extends Component {

	 constructor(props){
		super(props)
		this.handleSubmit=this.handleSubmit.bind(this)
		const urlParams=qs.parse(window.location.search.slice(1))

		this.state={
			error: null, 
			submitLoading:false,
			user:urlParams.user,
			token:urlParams.token,
			passwordUpdated:false
		}

	}
	
	handleSubmit(data){
		this.setState({submitLoading:true})
		const requestData={
			password:data.password,
			token:this.state.token

		}
 		this.props.resetPassword(this.state.user,requestData).then((response) => {
			this.setState({submitLoading:false,passwordUpdated:true})


		})
			.catch(error => {
				this.setState({submitLoading:false})
				let errorMessage='Please try again. If the problem persists, contact support.'
				if(error.response.status===404){
					errorMessage=`We couldn’t find an account with the email ${data.email}`
				}
				this.setState({error:errorMessage})
			})

	}


	render() {
		
		const {passwordUpdated} = this.state

		return (
			<DocumentTitle title='Reset Password - Plickers'>
				<div className='resetPassword marketing'>									
					
					
					<div className='resetPassword-centerBlock'> 

						<div className='resetPassword-centerBlock--top' />											

						<div className='resetPassword-centerBlock--middle'>
							<div className='resetPassword-centerBlock-title'>
								Reset Password
							</div>
							
							{!passwordUpdated &&
								<React.Fragment>
									<div className='resetPassword-centerBlock-subtitle'>
										Your new Plickers password should be at least six characters.
									</div>
								
									<ResetPasswordForm 
										signupError={this.state.error} 
										onPreSubmit={this.onPreSubmit}
										onSubmit={this.handleSubmit} 
										loginError={this.state.loginError} 
										submitLoading={this.state.submitLoading}
									/>
									
								</React.Fragment>
							}
							{passwordUpdated &&
								<div className='resetPassword-centerBlock-subtitle'>
									Your Plickers password is now updated.
								</div>
							}
						
						</div>
					
					
					</div>							
		
				</div>
			</DocumentTitle>
		)
	}
}


export default withRouter(connect(
	(state) => ({

	} ),
	{ resetPassword
		 })(ResetPasswordContainer))
